export enum SearchInputVariant {
  DEFAULT = 'default',
  GLOBAL_SEARCH = 'GlobalSearch',
  GLOBAL_SEARCH_NEW_UI = 'GlobalSearchNewUI',
}
